const stateHK = {
  hongKong: 'Hong Kong',
  newTerritories: 'New Territories',
  kowloon: 'Kowloon',
};

export default stateHK;
